import commonEChartLineProps from '@/theme/default/components/charts/echarts/mixins/common/commonEChartLineProps'

export default {
  mixins: [commonEChartLineProps]
}
